

import UploadCalendar from "../views/Calendar/UploadCalendar";


import DateRangeIcon from '@material-ui/icons/DateRange';

const uploadCalendarRoutes = [
    {
        path: "/upload-calendar",
        sidebarName: "UploadCalendar",
        navbarName: "UploadCalendar",
        icon: DateRangeIcon,
        component: UploadCalendar
    },
    {redirect: false, path: "/", to: "/upload-calendar", navbarName: "Redirect"}
];

export default uploadCalendarRoutes;



// WEBPACK FOOTER //
// ./src/routes/upload_calendar.jsx